import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=11bd0312&scoped=true&"
import script from "./MaintenancePage.vue?vue&type=script&lang=js&"
export * from "./MaintenancePage.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=11bd0312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd0312",
  null
  
)

export default component.exports